/* global System window */

import {
  trimSlash,
  isCx5,
} from './util';

const configUndefined = () => undefined;

const detectVersion = () => (window.portalClient ? '6' : '5');

const globalConfig = (window.BB && window.BB.config)
  ? param => window.BB.config[param]
  : configUndefined;

const b$Config = b$Portal => param => {
  if (param === 'contextRoot') {
    return b$Portal.config.resourceRoot;
  }
  return b$Portal[param];
};

const cx5Config = (window.b$ && window.b$.portal)
  ? b$Config(window.b$.portal)
  : configUndefined;

const cx6Config = (window.portalClient && window.portalClient.getFeature)
  ? param => window.portalClient.getFeature('cxp').config.get(param)
  : configUndefined;

const config = (param, version) => {
  const globalVar = globalConfig(param);
  if (globalVar !== undefined) {
    return globalVar;
  }
  return (isCx5(version)) ? cx5Config(param) : cx6Config(param);
};

const fallbackStaticResourcesRoot = (version) => {
  const contextRoot = trimSlash(config('contextRoot', version));
  if (isCx5(version)) {
    return `${contextRoot}/static`;
  }
  return `${contextRoot}/static/items`;
};

const pageConfig = () => {
  const version = globalConfig('version') || detectVersion();
  return {
    version,
    portalName: config('portalName', version),
    pageName: config('pageName', version),
    staticResourcesRoot: trimSlash(config('staticResourcesRoot', version))
      || fallbackStaticResourcesRoot(version),
  };
};

export default pageConfig;



// WEBPACK FOOTER //
// ./config-bb-module-loader/scripts/page.js